import React from 'react';
import { Link } from 'react-router-dom';
import Arrow from '@/components/Arrow';
import styles from './index.module.scss';

export interface NavItemProps {
  title: React.ReactNode;
  description: string;
  link?: string;
  active?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
}

export default function NavItem({
  title,
  description,
  link,
  active = false,
  onClick,
  onMouseEnter,
}: NavItemProps) {
  return (
    <button
      type="button"
      className={`${styles.item} ${active ? styles.active : ''}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      <span className={styles.title}>{title}</span>
      {active ? (
        <span className={styles.detail}>
          <span className={styles.desc}>{description}</span>
          {link ? (
            <Link className={styles.link} to={link} onClick={(e) => e.stopPropagation()}>
              查看详情
              <Arrow className={styles.arrow} color="#3370ff" aria-hidden />
            </Link>
          ) : null}
        </span>
      ) : null}
    </button>
  );
}
